import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import './JobsNav.css';

// Allow quick navigation to headers in the form
class JobsNav extends React.Component {
  static propTypes = {
    location: PropTypes.object
  };

  render() {
    return (
      <div className='JobsNav-root'>
        <h2 className='JobsNav-header'>Quick Nav</h2>
        <Link className='JobsNav-link' to={'#list'}>Jobs List</Link>
        <Link className='JobsNav-link' to={'#department'}>Department Tag</Link>
        <Link className='JobsNav-link' to={'#country'}>Country Tag</Link>
      </div>
    );
  }
}

const connectedJobsNav = connect(
  (state) => ({
    location: state.router.location
  })
)(JobsNav);

export default connectedJobsNav;



// WEBPACK FOOTER //
// ./src/components/jobs/JobsNav/JobsNav.js